import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { number } from "prop-types";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
const token = localStorage.getItem('authToken');
class AddDonation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: "",
            userName: "",
            title: "",
            category: "",
            areaInput: "",
            categoryData: [],
            currentImageUrls: [],
            submissionStatus: null,
            currentImageUrl: null,
            submeet: false,
            errors: [],
            city: "",
            date: '',
            price:number,
            address:'',
            pincode:number,
            isDateValid: true,
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
        };
    }
    handleChange = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];
    
        files.forEach((file) => {
          if (file.size > this.state.maxSize) {
            errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
          } else {
            this.setState({
              textInput: file,
              currentImageUrl: URL.createObjectURL(file),
            });
          }
        });
    
        this.setState({ errors });
      };

    


    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ submeet: true });

        const { textInput, date, city, title, areaInput, category,pincode,price,address } = this.state;

        try {
          
            const formData = new FormData();
            formData.append('image', textInput);
            formData.append('title', title);
            formData.append('description', areaInput);
      
          

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                 
                        Authorization: `Bearer ${token}`, 
                    
                }
            };
            console.log("1");

            const response = await axios.post("https://samaj.aasmo.in/api/admin/donation", formData, config);

            if (response.status === 201) {
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                 this.props.history.push("/donationlist");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };
    

    render() {
        const { textInput, price,pincode,address, date, isDateValid,title, currentImageUrl, city, userName, category, categoryData, submeet, areaInput, submissionStatus } = this.state;
        const isNameValid = userName.trim().length > 0;
        const isTitleValid = title.trim().length > 0;
        const isCityValid = city?.trim().length > 0;


        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Add Donation</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                    className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                                    value={title}
                                    name="title"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ title: e.target.value });
                                    }}
                                />
                                {!isTitleValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                <label>Image</label>

                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet && "parsley-error"}`}
                  name="textInput"
                  required=""
                  onChange={this.handleChange}
                />
                {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
             
                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ areaInput: e.target.value });
                                    }}
                                ></textarea>
                                {areaInput === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddDonation));
